module.exports = __webpack_public_path__ + "static/media/d5.74b6825f.png";